export default "__VITE_ASSET__De9Q9rPW__"